export enum ClientStatusEnum {
    Deleted,
    Enabled,
    Disabled,
    RecoveryMode,
    Registration
}
